import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const useQuery = () => {
  const search = useLocation().search;
  return useMemo(() => {
    return new URLSearchParams(search);
  }, [search]);
};
